import { RootState } from "redux/rootReducer";

export const selectIsDownloadingScoringPDF = (state: RootState) =>
  state.pdfDownloadScoringInfo.loading;
export const pdfDownloadErrorMessage = (state: RootState) =>
  state.pdfDownloadScoringInfo.error;
export const pdfDownloadSuccessResponse = (state: RootState) =>
  state.pdfDownloadScoringInfo.pdfDownloadScoringInfoResponse;
